import React, { Component, useEffect, useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { downloadFile, transLabel, getBase64 } from '../translations/util';
import getList from "../Redux/actions/CommonServices";
import { Input, Form, Schema } from 'rsuite';
import { AddDocumentacionCaso, ComentarCaso } from '../Redux/actions/caseActions';
import { useCookies } from 'react-cookie';
import { v4 as uuidv4 } from 'uuid'

const { ArrayType, BooleanType, StringType, DateType, NumberType, ObjectType } = Schema.Types;
const Textarea = React.forwardRef((props, ref) => <Input style={{ width: "100%" }} {...props} as="textarea" ref={ref} />);

let modelA = Schema.Model({
    Mensaje: StringType(),
    Comentario: StringType(),
    Cerrar: BooleanType()
});

const Consulta = () => {
    const navigate = useNavigate();
    const currentCase = useSelector(state => state.userReducer);

    const translations = useSelector(state => state.translationReducer);
    const [translation, setTranslation] = useState([]);

    const [caso, setCaso] = useState({});
    const [documentos, setDocumentos] = useState([]);
    const [usuario, setUsuario] = useState({});
    const [seguimiento, setSeguimiento] = useState([]);
    const [estados, setEstados] = useState([]);
    const [empresa, setEmpresa] = useState({});
    const [empresaGrupo, setEmpresaGrupo] = useState({});
    const [pais, setPais] = useState({});

    const formRefA = React.useRef();
    const [formValueA, setformValueA] = React.useState({});
    const [formErrorA, setformErrorA] = React.useState({});

    const forceUpdate = React.useReducer(bool => !bool)[1];
    const [config, setConfig] = useState([]);
    let [files, setFiles] = useState([]);

    const dispatch = useDispatch();
    const msgRef = React.useRef();
    const cerrarRef = React.useRef();

    const [cookies, setCookie] = useCookies(['languaje']);
    let lan = (cookies.languaje == null) ? "ES" : cookies.languaje;

    const toPage = (page) => {
        navigate(page)
    }

    useEffect(() => {
        getList("Casos/GetByFrontId?Id=" + currentCase.data.idCaso, null, function (response) {
            setCaso(response.caso);
            setDocumentos(response.documentos);
            setUsuario(response.usuario);
            setSeguimiento(response.seguimiento);
            setEstados(response.estados);
            setEmpresa(response.empresa ?? {});
            setEmpresaGrupo(response.empresaGrupo ?? {});
            setPais(response.pais ?? {});
        });

        getList("Config/Get", null, function (response) {
            setConfig(response);
        });
    }, []);

    useEffect(() => {
        setTranslation(translations.data);
    }, [translations]);

    const formatDate = (value, name) => {
        if (value != null && value != "") {
            let date = new Date(value);

            var day = date.getDate();
            var month = date.getMonth();

            var hours = date.getHours();
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();

            if (day < 10) day = '0' + day;
            if (month < 10) month = '0' + (month + 1);

            if (hours < 10) hours = '0' + hours;
            if (minutes < 10) minutes = '0' + minutes;
            if (seconds < 10) seconds = '0' + seconds;

            let dateAsString = day + '/' + month + '/' + date.getFullYear() + ' ' + hours + ':' + minutes + ':' + seconds;
            
            if(name == "fecha_suceso" || name == "fecha_conocimiento")
                dateAsString = day + '/' + month + '/' + date.getFullYear();

            return dateAsString;
        }
        else {
            return "-";
        }
    }

    const hanledClickImage = (element) => {
        getList("CasosDocumentacion/GetById?Id=" + element.idCasoDocumentacion, null, function (response) {
            downloadFile(response.contenidoArchivo, response.nombreArchivo);
        });
    }

    const hanledComments_User = () => {
        var mensaje = document.getElementById("Mensaje").value;

        if (mensaje == null || mensaje == "") {
            msgRef.current.show("Debe ingresar un comentario válido", "Comentarios", 'error');
            return;
        }

        formValueA.IdCaso = caso.idCaso;
        formValueA.IdUser = caso.idUsuario;
        formValueA.Mensaje = mensaje;
        formValueA.TituloEstado = "";
        formValueA.Code = "COMENTARIOS_USUARIO";
        formValueA.Lan = lan;
        formValueA.Accion = "Comentario del usuario";
        console.log(formValueA);

        dispatch(ComentarCaso(formValueA, function (response) {
            console.log("test");
            window.location.reload();
        }));
    }

    const handleFileClick_User = event => {
        document.getElementById("hiddenFileInput").click();
    };

    const handleFileChange_User = e => {
        let theFile = e.target.files[0];
        let fileExt = theFile.name.split('.').pop();
        let uploadLockFileExt = config.filter(c => c.nombre == "UPLOAD_LOCK_FILE_EXTENSION")[0].value;

        if (theFile.length < 1) {
            return;
        }

        if (uploadLockFileExt.toLowerCase().indexOf(fileExt.toLowerCase()) != -1) {
            if (lan == "ES") {
                alert("Lo siento, este tipo de archivo no está permitido por razones de seguridad");
            }
            else {
                alert("Sorry, this file type is not allowed for security reasons");
            }

            return;
        }

        getBase64(theFile).then(result => {
            //const MIN_FILE_SIZE = 1024 // 1MB    
            //const MAX_FILE_SIZE = 5120 // 5MB                  
            const MAX_FILE_SIZE = 10240 // 10MB
            const fileSizeKiloBytes = theFile.size / 1024;

            if (fileSizeKiloBytes > MAX_FILE_SIZE) {
                alert(transLabel("case.fileSizeError"));
                return
            }

            let file = {};

            file.idx = uuidv4();
            file.idCasoDocumentacion = 0;
            file.idCaso = caso.idCaso;
            file.nombreArchivo = theFile.name;
            file.extensionArchivo = theFile.name.split(".")[1];
            file.contenidoArchivo = result;
            file.esPrivado = 0;
            file.usuCrea = caso.idUsuario;
            file.usuModi = caso.idUsuario;

            if (files.length == 0) {
                files = new Array();
            }

            files.push(file);
            setFiles(files);

            forceUpdate();
        }).catch(err => {
            //console.log(err);
        });
    };

    const hanledUploadFiles_User = async () => {
        if (!files) {
            return;
        }

        for (const file of files) {
            await AddDocumentacionCaso(file, function (response) {
            })
        }

        window.location.reload();
    };

    const { t } = useTranslation();

    return (
        <>
            <Header />
            {/* ======= Banner Inboard ======= */}
            <div id="banner-inboard" className="container-fluid">
                <div className="d-flex align-items-center ps-4">
                    <img className="float-start" src="assets/img/capital-letter-ethics-channel-ayesa.png" />
                    <h1 className="ps-3 text-white">{transLabel("case.title2")}</h1>
                </div>
            </div>{/* End Banner Inboard */}
            {/* ======= Breadcrumb ======= */}
            <nav className="ps-3" style={{ backgroundColor: '#F3F3F3' }} aria-label="breadcrumb">
                <ol className="breadcrumb py-2">
                    <li className="breadcrumb-item"><a href="#" onClick={(e) => { toPage("/"); }}>{transLabel("NewCase.title")}</a></li>
                    <li className="breadcrumb-item active" aria-current="page">{transLabel("case.title2")}</li>
                </ol>
            </nav>
            {/* End Breadcrumb */}
            {/* ======= Datos del hecho ======= */}
            <div className="container">
                <div className="row mt-5">
                    <div className="icon-clear col-md-1 position-relative">
                        <img className="position-absolute end-0" src="assets/img/icon-info-event.png" />
                    </div>
                    <div className="col-lg-8 col-md-11 col-sm-12 pt-2">
                        <h2 style={{ fontWeight: 600 }}>{transLabel("case.title")}</h2>
                        <h4>{transLabel("case.descCaso1")}</h4>
                        <p>{caso.descCaso}</p>
                    </div>
                    {/* Línea separación */} <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                </div>{/* End Datos del hecho */}
                {/* ======= Archivos adjuntos ======= */}
                <div className="row mt-5">
                    <div className="col-md-11 offset-md-1">
                        <h4 className="mb-4">{transLabel("Consulta.datosAdjuntos")}</h4>
                        {documentos.map((element) =>
                            <button type="button" onClick={(e) => { hanledClickImage(element); }} className="btn btn-light">{element.nombreArchivo}<span className="ms-3" style={{ fontFamily: 'Material Icons' }}>file_download</span></button>
                        )}
                    </div>
                    {/* Línea separación */} <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                </div>{/* End Archivos adjuntos */}
                <div className="row mt-5">
                    <div className="col-md-2 pt-2 offset-md-1">
                        <h4>{transLabel("Consulta.Suceso")}</h4>
                        <p>{formatDate(caso.fechaInfraccion, "fecha_suceso")}</p>
                    </div>
                    <div className="col-md-2 pt-2">
                        <h4>{transLabel("Consulta.conocimiento")}</h4>
                        <p>{formatDate(caso.fechaConocimientoInfraccion, "fecha_conocimiento")}</p>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-6 col-md-11 pt-2 offset-md-1">
                        <h4>{transLabel("Consulta.formadeconocimiento")}</h4>
                        <p>{caso.modoConocimientoInfraccion}</p>
                    </div>
                </div>
                {/* Línea separación */} <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                {/* ======= Localización ======= */}
                <div className="row offset-md-1 mt-5">
                    <div className="col-md-6 col-lg-2">
                        <h4>{transLabel("Consulta.Pais")}</h4>
                        <p>{pais.tituloPais}</p>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <h4>{transLabel("Consulta.EmpresadelgrupoAyesa")}</h4>
                        <p>{empresaGrupo?.tituloEmpresa}</p>
                    </div>
                    <div className="col-md-6 col-lg-6">
                        <h4>{transLabel("Consulta.Departamentoenelqueseproduce")}</h4>
                        <p>{caso.departamento}</p>
                    </div>
                </div>{/* End Localización */}
                {/* Línea separación */} <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                {/* ======= Identificación ======= */}
                <div className="row offset-md-1 mt-5">
                    <div className="col-md-5 ">
                        <h4>{transLabel("Consulta.Identificacióndepersonasimplicadas")}</h4>
                        <p>{caso.nombreInfractor}</p>
                    </div>
                    <div className="col-md-4">
                        <h4>{transLabel("Consulta.Entidad")}</h4>
                        <p>{caso.entidadJuridica}</p>
                    </div>
                </div>{/* End Identificación */}
            </div>
            {/* ======= Información de contacto ======= */}
            <div className="container-fluid py-5 my-5" style={{ backgroundColor: '#F3F3F3' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-1 position-relative">
                            <img className="icon-clear position-absolute end-0" src="assets/img/icon-user.png" />
                        </div>
                        <div className="col-md-7 pt-2">
                            <h2 style={{ fontWeight: 600 }}>{transLabel("Consulta.Informaciondecontacto")}</h2>
                        </div>
                    </div>
                    {/* ======= Datos personales ======= */}
                    <div className="row offset-md-1 mt-5">
                        <div className="col-md-4">
                            <h4>{transLabel("Consulta.Nombreyapellido")}</h4>
                            <p>{usuario.nombre} {usuario.apellido1} {usuario.apellido2}</p>
                        </div>
                        <div className="col-md-4">
                            <h4>{transLabel("Consulta.Vinculacionconelgrupo")}</h4>
                            <p>{usuario.vinculacion}</p>
                        </div>
                        <div className="col-md-4">
                            <h4>{transLabel("Consulta.Empresadelgrupo")}</h4>
                            <p>{empresa?.tituloEmpresa}</p>
                        </div>
                    </div>
                    <div className="row offset-md-1 mt-5">
                        <div className="col-md-4">
                            <h4>{transLabel("Consulta.Telefonodecontacto")}</h4>
                            <p>{usuario.telefono}</p>
                        </div>
                        <div className="col-md-4">
                            <h4>{transLabel("Consulta.Correoelectronico")}</h4>
                            <p>{usuario.eMail}</p>
                        </div>
                    </div>{/* End Datos personales */}
                </div>
            </div>{/* End Información de contacto*/}

            {/* ======= Estado ======= */}
            <div className="container">
                <div className="row mt-5">
                    <div className="icon-clear col-md-1 position-relative">
                        <img className="position-absolute end-0" src="assets/img/icon-tracking.png" />
                    </div>
                    <div className="col-md-7 pt-2">
                        <h2 style={{ fontWeight: 600 }}>{transLabel("Consulta.Estado")}</h2>
                    </div>
                </div>   
                {
                    estados &&
                        <>
                            <div className="row offset-md-1 mt-5">
                                <div className="col-md-4 col-lg-3" style={{ color: '#3479DD' }}>
                                    <h4><span style={{ fontFamily: 'Material Icons' }}>history</span> <span style={{ fontWeight: 600 }}>{estados.fecCrea}</span></h4>
                                </div>
                                <div className="col-md-8 col-lg-9">
                                    <h4>{estados.tipo}</h4>
                                    <p>{estados.descripcion}</p>
                                </div>
                            </div>
                            {/* Línea separación */}
                            <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                        </>
                }
            </div>           

            {/* ======= Adjuntos ======= */}
            <div className="container">
                <div className="row mt-5">
                    <div className="icon-clear col-md-1 position-relative">
                        <img className="position-absolute end-0" src="assets/img/icon-info-event.png" />
                    </div>
                    <div className="col-md-7 pt-2">
                        <h2 style={{ fontWeight: 600 }}>{transLabel("Consulta.datosAdjuntos")}</h2>
                    </div>
                </div>
                {
                    documentos.length > 0 &&
                    <>
                        <div className="row offset-md-1 mt-5">
                            {documentos.map((element) =>
                                <>
                                    <div className="col-md-4 col-lg-3" style={{ color: '#3479DD' }}>
                                        <h4><span style={{ fontFamily: 'Material Icons' }}>history</span> <span style={{ fontWeight: 600 }}>{formatDate(element.fecCrea, "fecha_creacion")}</span></h4>
                                    </div>
                                    <div className="col-md-8 col-lg-9">
                                        <h4>Archivo adjunto</h4>
                                        <button onClick={(e) => { hanledClickImage(element); }} type="button" className="btn btn-light">{element.nombreArchivo}<span className="ms-3" style={{ fontFamily: 'Material Icons' }}>file_download</span></button>
                                    </div>
                                </>
                            )}
                        </div>
                        {/* Línea separación */}
                        <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                    </>
                }
            </div>

            {/* ======= Seguimiento ======= */}
            <div className="container">
                <div className="row mt-5">
                    <div className="icon-clear col-md-1 position-relative">
                        <img className="position-absolute end-0" src="assets/img/icon-history.png" />
                    </div>
                    <div className="col-md-7 pt-2">
                        <h2 style={{ fontWeight: 600 }}>{transLabel("Consulta.Seguimiento")}</h2>
                    </div>
                </div>
                <div className="row offset-md-1 mt-5">
                    <div className="col-md-4 col-lg-3" style={{ color: '#3479DD' }}>
                        <h4><span style={{ fontFamily: 'Material Icons' }}>history</span> <span style={{ fontWeight: 600 }}>{formatDate(caso.fecCrea, "fecha_creacion")}</span></h4>
                    </div>
                    <div className="col-md-8 col-lg-9">
                        <h4>{transLabel("Consulta.Fechadelsuceso")}</h4>
                        <p>{formatDate(caso.fechaInfraccion, "fecha_suceso")}</p>
                    </div>
                </div>
                {/* Línea separación */}
                <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />                
                {
                    seguimiento.map((element) =>
                        <>
                            <div className="row offset-md-1 mt-5">
                                <div className="col-md-4 col-lg-3" style={{ color: '#3479DD' }}>
                                    <h4><span style={{ fontFamily: 'Material Icons' }}>history</span> <span style={{ fontWeight: 600 }}>{element.fecCrea}</span></h4>
                                </div>
                                <div className="col-md-8 col-lg-9">
                                    <h4>{element.accion}</h4>
                                    {
                                        element.accion.includes("Comentario") ?
                                            <p>{element.descripcion}. Comentario del denunciante</p>
                                            :
                                            <p>{element.descripcion}. Oficina de cumplimiento</p>
                                    }
                                </div>
                            </div>
                            {/* Línea separación */}
                            <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                        </>
                    )
                }

                {
                    caso.idEstado == 2 &&
                    <>
                        <Form model={modelA} ref={formRefA} onChange={setformValueA} onCheck={setformErrorA} formValue={formValueA}>
                            <div className="container-fluid py-5 mt-5 col-sm-11 offset-md-1" style={{ backgroundColor: '#FCF5E5' }}>
                                <div className="container">
                                    <div className="row offset-md-1 mt-2">
                                        <div className="col-md-7">
                                            <h4>Comentario del usuario</h4>
                                            <div className="row">
                                                <div className="mb-3">
                                                    <Textarea id="Mensaje" name="Mensaje" placeholder="Introduzca su comentario" rows="10" cols="200" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="mb-5">
                                                    <button type="button" onClick={hanledComments_User} className="btn btn-primary ms-2">
                                                        <span style={{ position: 'relative', bottom: '2px' }}>Enviar</span>
                                                        <span className="ms-3" style={{ fontFamily: 'Material Icons', position: 'relative', top: '1px' }}>arrow_forward_ios</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <div className="row">
                                                <h4>Archivos</h4>
                                                <h5 style={{fontSize: '12px'}}>{transLabel("case.fileSize")}</h5>
                                                <div className="mb-3">
                                                    <button type="button" className="btn btn-secondary" onClick={handleFileClick_User}>
                                                        {transLabel("NewCase.attachfile")}
                                                        <span className="ms-3" style={{ fontFamily: "Material Icons" }}>attach_file</span>
                                                    </button>
                                                    <input type="file" id="hiddenFileInput" style={{ display: 'none' }} onChange={handleFileChange_User} value="" />
                                                    <button type="button" onClick={async () => { await hanledUploadFiles_User() }} className="btn btn-primary ms-2">
                                                        <span style={{ position: 'relative', bottom: '2px' }}>Enviar</span>
                                                        <span className="ms-3" style={{ fontFamily: 'Material Icons', position: 'relative', top: '1px' }}>arrow_forward_ios</span>
                                                    </button>
                                                </div>
                                                <div className="mb-3">
                                                    <ul>
                                                        {
                                                            files.map((file, i) => (
                                                                <li key={i}>
                                                                    {file.nombreArchivo}
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                        {/* Línea separación */}
                        <div className="col-md-11 offset-md-1 col-sm-12 pt-2 border-bottom pb-4" />
                    </>
                }
            </div>
            <Footer />
        </>
    );
}

export default Consulta;